module.exports = {"510683100":"剑南镇","510683101":"东北镇","510683102":"西南镇","510683103":"兴隆镇","510683104":"九龙镇","510683105":"遵道镇","510683106":"汉旺镇","510683108":"拱星镇","510683109":"土门镇","510683110":"广济镇","510683111":"金花镇","510683112":"玉泉镇","510683113":"板桥镇","510683115":"新市镇","510683116":"孝德镇","510683119":"富新镇","510683121":"齐天镇","510683122":"什地镇","510683123":"绵远镇","510683124":"清平镇","510683201":"天池乡","510683400":"四川绵竹经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510683.json
// module id = 2299
// module chunks = 0